import { render, staticRenderFns } from "./RoomInformationAndroid.vue?vue&type=template&id=31bf7af3&scoped=true&"
import script from "./RoomInformationAndroid.vue?vue&type=script&lang=ts&"
export * from "./RoomInformationAndroid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bf7af3",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31bf7af3')) {
      api.createRecord('31bf7af3', component.options)
    } else {
      api.reload('31bf7af3', component.options)
    }
    module.hot.accept("./RoomInformationAndroid.vue?vue&type=template&id=31bf7af3&scoped=true&", function () {
      api.rerender('31bf7af3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/rooms/RoomInformationAndroid.vue"
export default component.exports